import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const helpers = createMultiStyleConfigHelpers(tagAnatomy.keys);
export default helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      borderRadius: 'sm'
    },
    label: {
      color: 'text.body',
      fontSize: 'xs'
    }
  },
  sizes: {
    sm: {
      container: {
        height: '21px',
        fontSize: '11px'
      }
    }
  },
  variants: {
    outline: {
      container: {
        backgroundColor: 'CARNABY.extraLight',
        '--badge-color': 'var(--chakra-colors-CARNABY-light)'
      }
    },
    goal: {
      container: {
        borderRadius: 'full'
      },
      label: {
        textTransform: 'uppercase',
        fontWeight: 600
      }
    },
    informational: {
      container: {
        bg: 'GREYSCALE.SUPERNOVA',
        fontWeight: 300
      }
    }
  }
});